module.exports = __webpack_public_path__ + "img/shiba-body-level6.f478536f.png";